/*
$(window).scroll(function(){
  var sticky = $('.header'),
      scroll = $(window).scrollTop();

  if (scroll >= 50) sticky.addClass('fixed');
  else sticky.removeClass('fixed');
});
*/

$(document).ready(function() {

  $('#top-bar-mobile .subscription-btn').click(function(){
    $('#subscription-form').slideToggle('slow')
    $('.subscription-btn i').toggleClass('fa-angle-up')
  });

  $('#find-in-store-btn').click(function(){ 
    var popupBlock = $('#'+$(this).data('popup'));
    popupBlock.addClass('active')
    .find('.fade-out').click(function(){
      popupBlock.css('opacity','0').find('.popup-content').css('margin-top','350px');        
      setTimeout(function(){
        $('.popup').removeClass('active');
        popupBlock.css('opacity','').find('.popup-content').css('margin-top','');
      }, 600);
    });
  });
  
  // Filters accrocchius
  var storeUrl = $('body').attr('data-url-file');

  setTimeout(function(){
    $('[data-filter-name=Color] .cloud-search-filter-value,[data-filter-name=color] .cloud-search-filter-value').each(function(){
      var itemColor = $(this).attr('data-filter-value');
      var itemCheckbox = $(this).find('input[type=checkbox]');
      var urlFileName = storeUrl + itemColor + '.jpg'; 
  
      //console.log(urlFileName);
      itemCheckbox.attr('style','background-image: url("'+ urlFileName +'")');
    });
  },2000)

});  
